import { CardClickPopupType } from '@colonist/game-card-types';
import { CardEnum, CardTypeEnum, TurnState } from '@colonist/game-states';
export function getProgressCardDataTrade() {
    return [
        {
            cardEnum: CardEnum.ProgressCardTradeBack,
            cardTypeEnum: CardTypeEnum.ProgressTrade,
            isCardBack: true,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined
        },
        {
            cardEnum: CardEnum.ProgressCardTradeCommercialHarbor,
            cardTypeEnum: CardTypeEnum.ProgressTrade,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardTradeMasterMerchant,
            cardTypeEnum: CardTypeEnum.ProgressTrade,
            isCardBack: false,
            clickPopupType: CardClickPopupType.NormalClick,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardTradeMerchant,
            cardTypeEnum: CardTypeEnum.ProgressTrade,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardTradeMerchantFleet,
            cardTypeEnum: CardTypeEnum.ProgressTrade,
            isCardBack: false,
            clickPopupType: CardClickPopupType.NormalClick,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardTradeResourceMonopoly,
            cardTypeEnum: CardTypeEnum.ProgressTrade,
            isCardBack: false,
            clickPopupType: CardClickPopupType.NormalClick,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardTradeCommodityMonopoly,
            cardTypeEnum: CardTypeEnum.ProgressTrade,
            isCardBack: false,
            clickPopupType: CardClickPopupType.NormalClick,
            allowableTurnStates: [
                TurnState.Turn
            ]
        }
    ];
}
